import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EmployeeService } from 'src/app/views/employee-profile/employee-profile.service';
import { CompetenciesService } from 'src/app/views/competencies/competencies.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-edit-competency-dialog',
  templateUrl: './edit-competency-dialog.component.html',
  styleUrls: ['./edit-competency-dialog.component.css']
})
export class EditCompetencyDialogComponent implements OnInit {

  competencies: any[] = [];
  subCompetencies: any[] = [];
  selectedCompetencyId: number = null;
  selectedSubCompetency: string = '';
  comments: string = '';
  searchText: string = " ";
  from: number = 0;
  size: number = 10;
  public dataSource: MatTableDataSource<any>;
    @ViewChild(MatSort) sort: MatSort;
    totalRecords: number = 0;
    employeeId :any;
    selectedCompetency :any;
    subCompetencyName:any;
  // Define HTTP headers for the API request (including Authorization token)
  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token') // Assumes token is stored in localStorage
    })
  };

  private apiUrl = environment.apiUrl; // Your API base URL
  loading: boolean;

  constructor(
    private dialogRef: MatDialogRef<EditCompetencyDialogComponent>,
    private _employeeService: EmployeeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private _competencyService: CompetenciesService,
    private toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.employeeId = parseInt(localStorage.getItem("Id"));
    // Fetch competencies on dialog load
    this.fetchCompetencyData();
  }

  // Fetch competency data from the API
  fetchCompetencyData(): void {
    this._employeeService.getCompetencies().subscribe((response) => {
      this.competencies = response.data;
    });
  }

  // Fetch sub-competencies based on selected competency ID
  onCompetencyChange(): void {
    if (this.selectedCompetency) {
      this._employeeService.getSubcompetencies(this.selectedCompetency).subscribe((response)=>{
        this.subCompetencies = response.data;
      })
    }
  }

  // Close the dialog without saving
  onCancel(): void {
    this.dialogRef.close();
  }

  // Save the selected data
  onSave(employeeId): void {
    const saveData = {
      competency: this.selectedCompetencyId,
      subCompetency: this.selectedSubCompetency,
      comments: this.comments
    };
    const empIds: any = [];
    empIds.push(employeeId);
    const competencyName = this.competencies.find((item) => item.id === this.selectedCompetency);
    const subCompetencyName = this.subCompetencies.find((item) => item.id === this.selectedSubCompetency);
    let data: any = {
      employeesList: empIds,
      selectedCompetency: competencyName && competencyName.name ? competencyName.name : '',
      selectedSubCompetencies: subCompetencyName && subCompetencyName.name ? subCompetencyName.name : '',
    }
    this._competencyService.AddCompetencyinfo(data).subscribe((res: any) =>{
      if (res.succeeded === true) {
        // this.toaster.success("Successfully Added Competency Info");
        setTimeout(() => {this.GetNoCompetencyData(); }, 1000);
        this.dialogRef.close(true);
      } else {
        this.toaster.error("Something went wrong..");
        this.dialogRef.close();
      }
    })
  }

    GetNoCompetencyData() {
      this.loading = true;
      return this._competencyService.GetNoCompetencyData(this.searchText, this.from, this.size).subscribe(x => {
        this.dataSource = new MatTableDataSource(x.data.items);
        this.dataSource.sort = this.sort;
        this.totalRecords = x.data.total;
        this.loading = false;
      });
    }
}

